export const KIND_COLORS: Record<string, string> = {
  textarea: 'bg-blue-100 text-blue-800',
  text: 'bg-blue-100 text-blue-800',
  select_single: 'bg-purple-100 text-purple-800',
  select_multi: 'bg-purple-100 text-purple-800',
  upload: 'bg-green-100 text-green-800',
  file: 'bg-green-100 text-green-800',
  checkbox: 'bg-orange-100 text-orange-800',
  date: 'bg-yellow-100 text-yellow-800',
  number: 'bg-gray-100 text-gray-700',
};

export function templateLabel(t: {
  category: string;
  sub_category: string;
  variant: string;
}): string {
  return [t.category, t.sub_category, t.variant].filter(Boolean).join(' — ');
}
